import { render, staticRenderFns } from "./lydia.svg.vue?vue&type=template&id=175b380a&"
import script from "./lydia.svg.vue?vue&type=script&lang=js&"
export * from "./lydia.svg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports